import { render } from "./xtx-carousel.vue?vue&type=template&id=775a2b46&scoped=true"
import script from "./xtx-carousel.vue?vue&type=script&lang=js"
export * from "./xtx-carousel.vue?vue&type=script&lang=js"

import "./xtx-carousel.vue?vue&type=style&index=0&id=775a2b46&scoped=true&lang=less"

import exportComponent from "F:\\workspan\\java\\lot\\hk-lottery-lhc-pc-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-775a2b46"]])

export default __exports__